export default "__VITE_ASSET__ClJh0kF5__"